export default __webpack_public_path__ + "media/images/testimonials/testimonial-bg-961d2fb3ceb9e23def7ecec9162a9eb3.svg";